// extracted by mini-css-extract-plugin
module.exports = {"Personality":"personality_Personality__3IN3z","Personality__h3":"personality_Personality__h3__xdA7f","Personality__table":"personality_Personality__table__1RK81"};